import { useFilters } from '../../contexts/FilterContext'
import { Filter, X, Calendar } from 'lucide-react'
import styles from './GlobalFilterBar.module.css'

export function GlobalFilterBar() {
  const {
    filters,
    filterOptions,
    setDataInicio,
    setDataFim,
    setTipoNegocio,
    setIdEmpreendimento,
    setIdCorretor,
    setIdImobiliaria,
    clearFilters,
    isLoading,
  } = useFilters()

  const hasActiveFilters =
    filters.tipoNegocio !== 'global' ||
    filters.idEmpreendimento !== null ||
    filters.idCorretor !== null ||
    filters.idImobiliaria !== null

  // Filtra corretores pela imobiliaria selecionada
  const corretoresFiltrados = filters.idImobiliaria
    ? filterOptions.corretoresCompletos.filter(
        (c) => c.idImobiliaria === filters.idImobiliaria
      )
    : filterOptions.corretoresCompletos

  return (
    <div className={styles.filterBar}>
      <div className={styles.filterIcon}>
        <Filter size={22} />
      </div>

      {/* Date Range */}
      <div className={styles.dateRange}>
        <Calendar size={20} />
        <input
          type="date"
          className={styles.dateInput}
          value={filters.dataInicio}
          onChange={(e) => {
            const value = e.target.value
            const year = parseInt(value.split('-')[0], 10)
            if (year >= 1900 && year <= 2100) {
              setDataInicio(value)
            }
          }}
        />
        <span>a</span>
        <input
          type="date"
          className={styles.dateInput}
          value={filters.dataFim}
          onChange={(e) => {
            const value = e.target.value
            const year = parseInt(value.split('-')[0], 10)
            if (year >= 1900 && year <= 2100) {
              setDataFim(value)
            }
          }}
        />
      </div>

      {/* Tipo Negocio */}
      <select
        className={styles.select}
        value={filters.tipoNegocio}
        onChange={(e) => setTipoNegocio(e.target.value as 'global' | 'realiza' | 'invest')}
      >
        <option value="global">Todas as Linhas</option>
        <option value="realiza">FAJ Realiza (MCMV)</option>
        <option value="invest">FAJ Invest</option>
      </select>

      {/* Empreendimento */}
      <select
        className={styles.select}
        value={filters.idEmpreendimento || ''}
        onChange={(e) => setIdEmpreendimento(e.target.value ? Number(e.target.value) : null)}
        disabled={isLoading}
      >
        <option value="">Todos os Empreendimentos</option>
        {filterOptions.empreendimentos.map((emp, index) => (
          <option key={emp.value ?? `emp-${index}`} value={emp.value}>
            {emp.label}
          </option>
        ))}
      </select>

      {/* Imobiliaria */}
      <select
        className={styles.select}
        value={filters.idImobiliaria || ''}
        onChange={(e) => setIdImobiliaria(e.target.value ? Number(e.target.value) : null)}
        disabled={isLoading}
      >
        <option value="">Todas as Imobiliarias</option>
        {filterOptions.imobiliarias.map((imob, index) => (
          <option key={imob.value ?? `imob-${index}`} value={imob.value}>
            {imob.label}
          </option>
        ))}
      </select>

      {/* Corretor */}
      <select
        className={styles.select}
        value={filters.idCorretor || ''}
        onChange={(e) => setIdCorretor(e.target.value ? Number(e.target.value) : null)}
        disabled={isLoading}
      >
        <option value="">
          {filters.idImobiliaria ? 'Corretores da Imobiliaria' : 'Todos os Corretores'}
        </option>
        {corretoresFiltrados.map((corr, index) => (
          <option key={corr.value ?? `corr-${index}`} value={corr.value}>
            {corr.label}
          </option>
        ))}
      </select>

      {/* Clear Filters Button */}
      {hasActiveFilters && (
        <button className={styles.clearAll} onClick={clearFilters}>
          <X size={18} />
          Limpar Filtros
        </button>
      )}
    </div>
  )
}
